export default __webpack_public_path__ + "static/web-transforming-analytics-86a0e88f5381dad9a4178b47d628aa38.png";